import { SectionHeaderProps } from "../FieldSchema/types";

export interface SectionHeaderPropsWrapper extends Omit<SectionHeaderProps, "type"> {
  type?: "Section";
}

export const SectionHeader: React.FC<SectionHeaderPropsWrapper> = ({
  label,
  hidden,
  className = "",
}) => {
  if (hidden) {
    return null;
  }
  return (
    <div className={("section-header-container " + className).trim()}>
      <h4 className="section-header">{label}</h4>
    </div>
  );
};
